import styled from "styled-components";
import { transition, AutoComplete as UIAutoComplete } from "@evergis/ui";

import { MapControlContainer } from "../../styled";

type AutoCompleteProps = {
  isVisible?: boolean;
};
export const AutoComplete = styled(UIAutoComplete)`
  width: ${({ isVisible }: AutoCompleteProps) => (isVisible ? "18rem" : "0")};
  opacity: ${({ isVisible }: AutoCompleteProps) => (isVisible ? "1" : "0")};
  border: ${({ isVisible }: AutoCompleteProps) => (isVisible ? void 0 : "none")};
  padding: ${({ isVisible }: AutoCompleteProps) => (isVisible ? void 0 : "0")};
  height: 2rem;
  transition: ${transition.show};
  transition-property: width, padding;
`;

export const AddressSearchContainer = styled(MapControlContainer)`
  position: relative;
  padding: 0 0.25rem;
`;
